import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  CityProps,
  StateProps,
} from "../../../../../domain/models/address.model";
import { DeveloperCompanyModel } from "../../../../../domain/models/developer-company.model";
import { StackModel } from "../../../../../domain/models/stacks";
import { makeRemoteAddresss } from "../../../../../main/factories/usecases/address-controller/remote-address-controller-factory";
import { especialTaxTypeList, taxTypeList } from "../../../../../utils";

export const getStack = (arr: any): any => {
  let obj = {};
  arr?.forEach((element: any) => {
    obj = { ...obj, [element?.id]: true };
  });
  return obj;
};

export const Fields = (
  data: DeveloperCompanyModel | undefined,
  stackList: StackModel[] | undefined
): any[] => {
  const [stateList, setStatesList] = useState<StateProps[]>([]);
  const [citiesList, setCitiesList] = useState<CityProps[]>([]);
  const [citiesListCompany, setCitiesListCompany] = useState<any>([]);
  const [stacks, setStacks] = useState<any>([]);
  const location = useLocation();
  const userNameEmail =
    localStorage.getItem("username") !== null
      ? localStorage.getItem("username")?.replace(/["]/g, "")
      : "";
  const loadCities = (initial: number): void => {
    (async () => {
      const citiesData = await makeRemoteAddresss().loadCities(initial);
      setCitiesList(citiesData);
    })();
  };
  const loadCitiesCompany = (initial: number): void => {
    (async () => {
      const citiesData = await makeRemoteAddresss().loadCities(initial);
      setCitiesListCompany(citiesData);
    })();
  };

  useEffect(() => {
    if (data?.developer?.otherStack) {
      setStacks(
        data?.developer?.otherStack
          .split("; ")
          .map((item) => ({ id: item, text: item }))
      );
    }
    const defaultState = data?.developer?.address?.city?.state?.id;
    if (defaultState) {
      loadCities(defaultState);
    }
    const defaultStateCompany = data?.company?.address?.city?.state?.id;
    if (defaultStateCompany) {
      loadCitiesCompany(defaultStateCompany);
    }
    (async () => {
      const statesData = await makeRemoteAddresss().loadStates();
      setStatesList(statesData);
    })();
  }, [data]);

  return [
    {
      groupName: "PERSONALDATA",
      groupLabel: "Dados pessoais:",

      items: [
        {
          name: "name",
          type: "text",
          label: "Nome",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.developer?.name,
          validations: "inputRequired",
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },
        {
          name: "cpf",
          type: "text",
          label: "CPF:",
          disabled: location?.pathname.includes("view"),
          mask: "000.000.000-00",
          defaultValue: data?.developer?.cpf,
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "email",
          type: "text",
          label: "E-mail:",
          disabled: location?.pathname.includes("view"),
          initialValue: userNameEmail ?? "",
          defaultValue: userNameEmail ?? data?.developer?.email,
          validations: "emailRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "telefone",
          type: "text",
          label: "Telefone:",
          disabled: location?.pathname.includes("view"),
          mask: "(00) 90000-0000",
          defaultValue: `(${data?.developer?.phone?.ddd}) ${data?.developer?.phone?.number}`,
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "stack",
          type: "checkboxGroup",
          label: "Stack:",
          disabled: location?.pathname.includes("view"),
          defaultValue: getStack(data?.developer?.stacks),
          // validations: 'inputRequired',
          options: stackList?.map((el) => ({
            value: el.id,
            label: el.description,
          })),
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },
        {
          name: "otherStack",
          type: "multipleValueText",
          label: "Outra Stack:",
          disabled: location?.pathname.includes("view"),
          defaultValue: stacks,
          // validations: 'inputRequired',
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
    {
      groupName: "ADDRESS",
      groupLabel: "Endereço Residencial:",

      items: [
        {
          name: "zipCode",
          type: "text",
          label: "CEP:",
          disabled: location?.pathname.includes("view"),
          mask: "00000-000",
          defaultValue: data?.developer?.address?.zipCode,
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        // {
        //   name: 'addressType',
        //   type: 'select',
        //   label: 'Tipo de Endereço:',
        //   disabled: location?.pathname.includes('view'),
        //   defaultValue: Number(addressTypeList?.find(
        //     (el) => el.ENUM === data?.developer?.address?.addressType,
        //   )?.value),
        //   validations: 'objectRequired',
        //   options: addressTypeList,
        //   col: {
        //     xs: 4,
        //     md: 4,
        //     lg: 4,
        //   },
        // },
        {
          name: "address",
          type: "text",
          label: "Endereço",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.developer?.address?.place,
          validations: "inputRequired",
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },
        {
          name: "number",
          type: "text",
          label: "Número:",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.developer?.address?.number,
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "district",
          type: "text",
          label: "Bairro:",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.developer?.address?.district,
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "complement",
          type: "text",
          label: "Complemento:",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.developer?.address?.complement,
          // validations: 'inputRequired',
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "state",
          type: "select",
          label: "Estado:",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.developer?.address?.city?.state?.id,
          validations: "objectRequired",
          onChange: (e: any) => {
            loadCities(e.value);
          },
          options: stateList.map((el) => ({ value: el?.id, label: el.name })),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "city",
          type: "select",
          label: "Cidade:",
          disabled: location?.pathname.includes("view"),
          options: citiesList?.map((el) => ({ value: el?.id, label: el.name })),
          defaultValue: data?.developer?.address?.city?.id,
          validations: "objectRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
    {
      groupName: "COMPANY",

      groupLabel: "Dados CNPJ:",
      items: [
        {
          name: "socialReason",
          type: "text",
          label: "Razão Social",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.company?.socialReason,
          validations: "inputRequired",
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },
        {
          name: "subscriptionNumber",
          type: "text",
          label: "CNPJ:",
          disabled: location?.pathname.includes("view"),
          mask: "SS.SSS.SSS/SSSS-00",
          defaultValue: data?.company?.subscriptionNumber,
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "stateRegistration",
          type: "text",
          label: "Inscrição Estadual:",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.company?.stateRegistration,
          // validations: 'inputRequired',
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "municipalRegistration",
          type: "text",
          label: "Inscrição Municipal:",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.company?.municipalRegistration,
          // validations: 'inputRequired',
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "fantasyName",
          type: "text",
          label: "Nome Fantasia",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.company?.fantasyName,
          validations: "inputRequired",
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },
        {
          name: "emailCompany",
          type: "text",
          label: "E-mail Cadastrado:",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.company?.email,
          validations: "emailRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "telefoneCompany",
          type: "text",
          label: "Telefone:",
          disabled: location?.pathname.includes("view"),
          mask: "(00) 90000-0000",
          defaultValue: `(${data?.company?.phone?.ddd}) ${data?.company?.phone?.number}`,
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "taxType",
          type: "select",
          label: "Regime Tributário:",
          disabled: location?.pathname.includes("view"),
          defaultValue:
            data?.company?.taxType &&
            taxTypeList?.find((el) => el.ENUM === data?.company?.taxType)
              ?.value,
          validations: "objectRequired",
          onChange: (e: any, setFieldValue: any) => {
            const value = e?.target?.value || e?.value;
            const selectedEnum = taxTypeList?.find((el) => String(el.value) === String(value))?.ENUM;
            if (setFieldValue && (selectedEnum === "SIMPLES_NACIONAL" || selectedEnum === "SIMPLES_NACIONAL_EXCESSO")) {
              setFieldValue("simpleNacional", true);
            }
          },
          options: taxTypeList,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "especialTaxType",
          type: "select",
          label: "Regime Tributário especial:",
          disabled: location?.pathname.includes("view"),
          defaultValue:
            data?.company?.especialTaxType &&
            especialTaxTypeList?.find(
              (el) => el.ENUM === data?.company?.especialTaxType
            )?.value,
          validations: "objectRequired",
          onChange: (e: any) => {
            loadCities(e.value);
          },
          options: especialTaxTypeList,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "simpleNacional",
          type: "checkbox",
          label: "Optante pelo SIMPLES Nacional:",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.company?.simpleNacional,
          // validations: 'inputRequired',
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "culturalIncentive",
          type: "checkbox",
          label: "Incentivo a Cultura:",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.company?.culturalIncentive,
          // validations: 'inputRequired',
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "taxIncentive",
          type: "checkbox",
          label: "Taxa de incentivo:",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.company?.taxIncentive,
          // validations: 'inputRequired',
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        // {
        //   name: 'rpsNumber',
        //   type: 'text',
        //   label: 'Número(RPS):',
        //   disabled: location?.pathname.includes('view'),
        //   defaultValue: data?.company?.rps?.numeracao[0].numero,
        //   validations: 'inputRequired',
        //   col: {
        //     xs: 2,
        //     md: 2,
        //     lg: 2,
        //   },
        // },
        // {
        //   name: 'rpsSerie',
        //   type: 'text',
        //   label: 'serie(RPS):',
        //   disabled: location?.pathname.includes('view'),
        //   defaultValue: data?.company?.rps?.numeracao[0].serie,
        //   validations: 'inputRequired',
        //   col: {
        //     xs: 4,
        //     md: 4,
        //     lg: 4,
        //   },
        // },
      ],
    },

    {
      groupName: "ADDRESS_COMPANY",

      groupLabel: "Endereço do CNPJ:",
      items: [
        {
          name: "zipCodeCompany",
          type: "text",
          label: "CEP:",
          disabled: location?.pathname.includes("view"),
          mask: "00000-000",
          defaultValue: data?.company?.address?.zipCode,
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        // {
        //   name: 'addressTypeCompany',
        //   type: 'select',
        //   label: 'Tipo de Endereço:',
        //   disabled: location?.pathname.includes('view'),
        //   defaultValue: data?.company?.address?.addressType
        //        && addressTypeList?.find(
        //          (el) => el.ENUM === data?.company?.address?.addressType,
        //        )?.value,
        //   validations: 'objectRequired',
        //   options: addressTypeList,
        //   col: {
        //     xs: 4,
        //     md: 4,
        //     lg: 4,
        //   },
        // },
        {
          name: "addressCompany",
          type: "text",
          label: "Endereço",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.company?.address?.place,
          validations: "inputRequired",
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },
        {
          name: "numberCompany",
          type: "text",
          label: "Número:",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.company?.address?.number,
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "districtCompany",
          type: "text",
          label: "Bairro:",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.company?.address?.district,
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "complementCompany",
          type: "text",
          label: "Complemento:",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.company?.address?.complement,
          // validations: 'inputRequired',
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },

        {
          name: "stateCompany",
          type: "select",
          label: "Estado:",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.company?.address?.city?.state?.id,
          validations: "objectRequired",
          onChange: (e: any) => {
            loadCitiesCompany(e.value);
          },
          options: stateList.map((el) => ({ value: el?.id, label: el.name })),
          // disabled: location?.pathname.includes('view'),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "cityCompany",
          type: "select",
          label: "Cidade:",
          disabled: location?.pathname.includes("view"),
          defaultValue: data?.company?.address?.city?.id,
          validations: "objectRequired",
          options: citiesListCompany?.map((el: CityProps) => ({
            value: el?.id,
            label: el.name,
          })),
          // disabled: location?.pathname.includes('view'),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
    // {
    //   groupName: 'PLAN',
    //   groupLabel: 'Plano:',

    //   items: [
    //     {
    //       name: 'package',
    //       type: 'select',
    //       label: 'Plano:',
    //       defaultValue: data?.developer?.pack?.id,
    //       validations: 'objectRequired',
    //       options: packageList?.map((el) => ({ value: el?.id, label: el.packageEnum })),
    //       // disabled: location?.pathname.includes('view'),
    //       col: {
    //         xs: 4,
    //         md: 4,
    //         lg: 4,
    //       },
    //     },
    //     {
    //       name: 'status',
    //       type: 'select',
    //       label: 'Status:',
    //       defaultValue: data?.developer?.,
    //       disabled: location?.pathname.includes('view'),
    //       options: [{ value: 'PAYMENT_CONFIRMED',
    // label: 'Pagamento confirmado' }, { value: '
    // PENDING_PAYMENT', label: 'Pagamento pendente' }],
    //       validations: 'objectRequired',
    //       col: {
    //         xs: 4,
    //         md: 4,
    //         lg: 4,
    //       },
    //     },
  ];
};
